// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.clip-zoom-container {
    display: flex;
    justify-content: end;
}

    .clip-zoom-container button {
        border-radius: 50%;
        width: 2rem;
        height: 2rem;
        display: flex;
    }

    .clip-zoom-container > div {
        padding: 0.5rem;
    }

.clip-zoom-slider {
    display: flex;
    flex-wrap: nowrap;
    align-content: center;
}

    .clip-zoom-slider > input {
        background-color: darkblue;
        cursor: pointer;
    }

    .clip-zoom-slider > input:hover {
        background-color: darkblue;
    }
`, "",{"version":3,"sources":["webpack://./src/ClipMaker/css/ClipZoom.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,oBAAoB;AACxB;;IAEI;QACI,kBAAkB;QAClB,WAAW;QACX,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;AAEJ;IACI,aAAa;IACb,iBAAiB;IACjB,qBAAqB;AACzB;;IAEI;QACI,0BAA0B;QAC1B,eAAe;IACnB;;IAEA;QACI,0BAA0B;IAC9B","sourcesContent":[".clip-zoom-container {\r\n    display: flex;\r\n    justify-content: end;\r\n}\r\n\r\n    .clip-zoom-container button {\r\n        border-radius: 50%;\r\n        width: 2rem;\r\n        height: 2rem;\r\n        display: flex;\r\n    }\r\n\r\n    .clip-zoom-container > div {\r\n        padding: 0.5rem;\r\n    }\r\n\r\n.clip-zoom-slider {\r\n    display: flex;\r\n    flex-wrap: nowrap;\r\n    align-content: center;\r\n}\r\n\r\n    .clip-zoom-slider > input {\r\n        background-color: darkblue;\r\n        cursor: pointer;\r\n    }\r\n\r\n    .clip-zoom-slider > input:hover {\r\n        background-color: darkblue;\r\n    }\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
